import React from 'react'
import { css } from '@emotion/react'
import { IcomoonIcon } from '../IcomoonIcon'
import { Tooltip } from 'plume-ui'

type Props = {
  className?: string
  isHiddenTooltip?: boolean
}

export const IPOIcon: React.FC<Props> = (props) => {
  return (
    <>
      {props.isHiddenTooltip === true ? (
        <IcomoonIcon
          name="ipo"
          css={css`
            color: #e0ce2e;
            font-size: 21px;
            vertical-align: text-bottom;
          `}
          className={props.className}
        />
      ) : (
        <>
          <Tooltip label="IPO（調査終了）">
            <IcomoonIcon
              name="ipo"
              css={css`
                color: #e0ce2e;
                font-size: 21px;
                vertical-align: text-bottom;
              `}
              className={props.className}
            />
          </Tooltip>
        </>
      )}
    </>
  )
}
